export class UnknownServerErrorException implements Error {
    public name = 'Unknown Server Error'
    public message = 'HTTP Request failed with 500 unknown server error!'
}
